'use client';

import { getFragmentData } from '@/__generated__';
import { PROGRAM_CATEGORY_FRAGMENT } from '@/gql/fragments/categories.gql';
import { ENTRY_BASE_FRAGMENT } from '@/gql/fragments/entries.gql';
import { PAGE_OVERVIEW_CARD_FRAGMENT } from '@/gql/fragments/entryCards.gql';
import { useColorScheme } from '@/lib/parsers/common';
import { withFragment } from '@liquorice/gql-utils';
import { excludeEmptyTypedElements, firstNonNullable, toBoolean } from '@liquorice/utils';
import Breadcrumbs from '../Breadcrumbs';
import Flex from '../ui/Flex';
import PageHeaderRoot from './PageHeaderRoot';
import PageSummary from './PageSummary';
import PageTitle from './PageTitle';

const PageHeaderOverview = withFragment(PAGE_OVERVIEW_CARD_FRAGMENT, (data) => {
  const base = getFragmentData(ENTRY_BASE_FRAGMENT, data);
  const programCategory = getFragmentData(
    PROGRAM_CATEGORY_FRAGMENT,
    firstNonNullable(excludeEmptyTypedElements(data?.programCategory))
  );
  const { colorScheme, oppositeScheme } = useColorScheme(
    programCategory?.colorScheme ?? data?.colorScheme
  );

  const isCentered = toBoolean(data?.centrePageHeader);

  if (!data) return null;

  return (
    <PageHeaderRoot variant="overview" colorSet={colorScheme} paper>
      <Flex spacing="xs" cx={{ mY: '5xl' }}>
        {!isCentered && <Breadcrumbs data={base} CtaButtonProps={{ color: oppositeScheme }} />}
        <PageTitle uppercase cx={{ textAlign: isCentered ? 'center' : 'left', mB: 'none' }}>
          {data.entryTitle}
        </PageTitle>
        {!isCentered && <PageSummary useGridCol={false}>{data.entrySummary}</PageSummary>}
      </Flex>
    </PageHeaderRoot>
  );
});

export default PageHeaderOverview;
